import React from 'react'

import { useSessionEntity } from '@context/EntityContext'

import { TickmillCompaniesEnum } from '@utils/companyName.utils'

import { TMEuropeLogo } from '@assets/logo/TMEurope.logo'
import { TMGenericLogo } from '@assets/logo/TMGeneric.logo'
import { TMPartnersLogo } from '@assets/logo/TMPartners.logo'
import { TMUKLogo } from '@assets/logo/TMUK.logo'
import { LogoProps } from '@assets/logo/types'

export const TMEntityLogo: Record<TickmillCompaniesEnum, React.FC<LogoProps>> = {
  [TickmillCompaniesEnum.GENERIC]: TMGenericLogo,
  [TickmillCompaniesEnum.TICKMILL_UAE]: TMGenericLogo,
  [TickmillCompaniesEnum.TICKMILL_PA]: TMPartnersLogo,
  [TickmillCompaniesEnum.TICKMILL_AS]: TMGenericLogo,
  [TickmillCompaniesEnum.TICKMILL_SC]: TMGenericLogo,
  [TickmillCompaniesEnum.TICKMILL_EU]: TMEuropeLogo,
  [TickmillCompaniesEnum.TICKMILL_UK]: TMUKLogo,
}

export const TMEntityLogoFactory: React.FC<LogoProps> = (props) => {
  const entity = useSessionEntity()

  const Logo = TMEntityLogo[entity]
  return <Logo {...props} />
}
